import React from "react";
import { Navigate, Route, Routes } from "react-router";
import AppShell from "./components/layout/AppShell";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicOnlyRoute from "./routes/PublicOnlyRoute";
import { paths } from "./routes/paths";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import Inconsistencies from "./pages/Inconsistencies";
import Projects from "./pages/Projects";
import Sprints from "./pages/Sprints";

function App() {
  return (
    <Routes>
      <Route element={<PublicOnlyRoute />}>
        <Route path={paths.login} element={<Login />} />
      </Route>

      {/* replace é obrigatório: sem ele, Voltar em /projects volta para "/",
          que redireciona de novo e prende o usuário. */}
      <Route path="/" element={<Navigate to={paths.projects} replace />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route path={paths.projects} element={<Projects />} />
          <Route path="/projects/:projectId/sprints" element={<Sprints />} />
          <Route path="/projects/:projectId/inconsistencies" element={<Inconsistencies />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
